import { Divider, Stack, Typography, useTheme } from "@mui/material";
import { FileText } from "lucide-react";
import { useEffect } from "react";
import { useDocumentListQuery } from "web_myplann/Api/Document/useDocumentListQuery";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";
import { DocumentItem } from "web_myplann/Portfolio/Components/Document/DocumentItem";
import { FolderItem } from "web_myplann/Portfolio/Components/FolderItem";

type Props = {
	setIsLoading: (isFetching: boolean) => void;
};

export const DocumentListPage: React.FunctionComponent<Props> = ({
	setIsLoading,
}) => {
	const theme = useTheme();
	const { t } = useResource();
	const { data, isLoading } = useDocumentListQuery();

	useEffect(() => {
		window.scrollTo(0, 0);
	}, []);

	useEffect(() => {
		setIsLoading(isLoading);
	}, [isLoading, setIsLoading]);

	return (
		<>
			{data?.documents?.length === 0 && data?.tags?.length === 0 ? (
				<Stack
					alignItems="center"
					justifyContent="center"
					height="85vh"
					data-testid="document-list-page"
				>
					<FileText strokeWidth={1} width={100} height={100} />
					<Typography>{t(Resources.DocumentDetail.noDocuments)}</Typography>
				</Stack>
			) : (
				<Stack
					divider={
						<Divider
							sx={{ borderWidth: 1, borderColor: theme.palette.grey[100] }}
						/>
					}
					data-testid="document-list-page"
				>
					{data?.tags?.map((item) => (
						<FolderItem key={item.title} item={item} />
					))}
					{data?.documents?.map((item, index) => (
						<Stack key={item.id}>
							<DocumentItem item={item} />
							{index === data?.documents?.length - 1 && (
								<Divider
									sx={{ borderWidth: 1, borderColor: theme.palette.grey[100] }}
								/>
							)}
						</Stack>
					))}
				</Stack>
			)}
		</>
	);
};
